import { Component, ViewChild } from '@angular/core';
import { AuthenticationService } from './services/authentication.service';
import { Router, NavigationStart } from '@angular/router';
import 'rxjs/add/operator/filter';
import { DBService } from './services/db.service';
import { ActivityStatus, Activity } from './model/activity';
import { Document } from './model/document';
import { MatDialog } from '../../node_modules/@angular/material';
import { FrequentQuestionsComponent } from './pages/partials/frequent-questions/frequent-questions.component';
import { HeaderComponent } from './pages/header/header.component';
import { Company } from './model/company';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [AuthenticationService, DBService]
})
export class AppComponent {

  @ViewChild(HeaderComponent) child: HeaderComponent;

  documentsCount: number;
  activitiesCount: number;

  company: Company;
  companies: Company[];

  opened: boolean;
  hideMenu: boolean;
  position = 'after';

  searchText: string;

  constructor(public dialog: MatDialog
    , private authService: AuthenticationService
    , private router: Router
    , private dbService: DBService) {
    this.documentsCount = 0;
    this.activitiesCount = 0;
    this.updateHideMenu(this.router.url);
    this.opened = !this.hideMenu;

    this.dbService.listWithUIDs<Company>('/companies')
      .then(companies => {
        this.companies = companies;
        this.company = this.companies.filter(c => c.uid == this.authService.getUserCompany())[0];
        console.log(this.company);
      })
      .catch(error => console.log(error));       

    console.log("ROUUUUTER", router);
    console.log("ROUUUUTER EVENTS", router.events);
    console.log("ROUUUUTER EVENTS FILTER", router.events.filter);

    router.events
    .filter(event => event instanceof NavigationStart)
    .subscribe((event: NavigationStart) => {
      this.updateHideMenu(event.url);
      this.opened = !this.hideMenu;

      this.dbService.list<Activity>('/activities')
        .then(activities => {
          if (!this.authService.isAdmin()) {
            activities = activities.filter(a => {
              return a.companyUID === this.authService.getUserCompany()
            });
          }

          this.activitiesCount = activities
          .filter(a => a.status === ActivityStatus.EXPIRED 
            || (a.expirationDate < Date.now() && a.status !== ActivityStatus.DONE))
            .length;
          console.log ("COUNT ACTIVITIES LISTA : " , activities.length);
          console.log ("COUNT ACTIVITIES : " , this.activitiesCount);
      });

      this.dbService.list<Document>('/documents')
        .then(documents => {
          if (!this.authService.isAdmin()) {
            documents = documents.filter(a => { 
              // if (a.companyUID === this.authService.getUserCompany()) {
                // console.log ("****** ");
                // // console.log ("Companhia do DOCUMENT : ", a.companyUID);
                // // console.log ("Companhia do USER : ", this.authService.getUserCompany());
                // // console.log ("São as MESMAS??? : ", );
                
                // console.log ("Data do Documento : ", a.expirationDate);
                // console.log ("Data do Documento STRING : ", a.expirationDateString);
                // console.log ("E já expirou???? : ", a.expirationDate < Date.now());
                // console.log ("****** ");
              // }
              return a.companyUID === this.authService.getUserCompany();
            });
            this.documentsCount = documents.filter(d => d.expirationDate < Date.now()).length;
            console.log ("DOCUMENTS LISTA LENGHT : " , documents.length); 
            console.log ("DOCUMENTS COUNT : " , this.documentsCount);
          }
      });
    });
  }

  private updateHideMenu(url: string) {
    this.hideMenu = url === '/login' || this.authService.getUser() == null;
  }

  logout() {
    this.authService.logout()
      .then(() => this.router.navigate(['/login']))
      .catch(error => console.log(error));
  }

  openFAQ() {
    const dialogRef = this.dialog.open(FrequentQuestionsComponent, {
      height: 'auto',
      width: '800px'
    });
  }

  goToSearch() {
    this.child.applyFilter(this.searchText);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts